module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/19-f97760b0087582a184e310b6b46229c8.jpg";